import { useProgramFull } from '@/shared/program/use-program-full';
import { EmptyState } from '@/shared/ui/empty-state';

import { LessonPage } from './lesson-page';

/** Stable authored references resolve against the learner's current curriculum. */
export function LessonReferencePage({ code }: { code: string }) {
  const { data: program, isPending, error } = useProgramFull();
  const lesson = program?.modules
    .flatMap((module) => module.activities)
    .find((activity) => activity.code === code && activity.kind === 'lesson');
  if (isPending)
    return (
      <p role="status" className="p-8">
        Loading lesson…
      </p>
    );
  if (!lesson)
    return (
      <EmptyState
        title="Lesson unavailable"
        description={error?.message ?? 'This lesson is not part of the current curriculum.'}
      />
    );
  return <LessonPage activityId={lesson.id} />;
}
